import React from "react";

const CoinIcon = ({ stroke = "#F1A21F" }: { stroke?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 17 17"
      fill="none"
      style={{
        width: "18px",
        height: "18px",
      }}
    >
      <path
        d="M0.75 2.83337V12C0.75 13.15 2.61583 14.0834 4.91667 14.0834C5.855 14.0834 6.72 13.9284 7.41667 13.6667M7.41667 13.6667V7.00004M7.41667 13.6667C7.41667 14.8167 9.2825 15.75 11.5833 15.75C13.8842 15.75 15.75 14.8167 15.75 13.6667V7.00004M9.08333 5.33337V2.83337"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.91667 4.91667C2.61583 4.91667 0.75 3.98333 0.75 2.83333C0.75 1.68333 2.61583 0.75 4.91667 0.75C7.2175 0.75 9.08333 1.68333 9.08333 2.83333C9.08333 3.98333 7.2175 4.91667 4.91667 4.91667Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.41667 10.3333C7.41667 11.4833 9.2825 12.4166 11.5833 12.4166C13.8842 12.4166 15.75 11.4833 15.75 10.3333M0.75 6.16663C0.75 7.31663 2.61583 8.24996 4.91667 8.24996C5.855 8.24996 6.72083 8.09496 7.41667 7.83329M0.75 9.08329C0.75 10.2333 2.61583 11.1666 4.91667 11.1666C5.855 11.1666 6.72 11.0116 7.41667 10.75M11.5833 9.08329C9.2825 9.08329 7.41667 8.14996 7.41667 6.99996C7.41667 5.84996 9.2825 4.91663 11.5833 4.91663C13.8842 4.91663 15.75 5.84996 15.75 6.99996C15.75 8.14996 13.8842 9.08329 11.5833 9.08329Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_246_868"
          x1="8.25"
          y1="2.83337"
          x2="8.25"
          y2="15.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC881E" />
          <stop offset="0.261428" stopColor="#F6EF89" />
          <stop offset="0.632068" stopColor="#D0A946" />
          <stop offset="1" stopColor="#F2CB69" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_246_868"
          x1="4.91667"
          y1="0.75"
          x2="4.91667"
          y2="4.91667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC881E" />
          <stop offset="0.261428" stopColor="#F6EF89" />
          <stop offset="0.632068" stopColor="#D0A946" />
          <stop offset="1" stopColor="#F2CB69" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_246_868"
          x1="8.25"
          y1="4.91663"
          x2="8.25"
          y2="12.4166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC881E" />
          <stop offset="0.261428" stopColor="#F6EF89" />
          <stop offset="0.632068" stopColor="#D0A946" />
          <stop offset="1" stopColor="#F2CB69" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CoinIcon;
